__webpack_require__.p = "https://assets-dev.nextorder.co/build-assets/dev-build-2026-06-19-1781867622-stable-dev/";